import React from 'react'
import { useHistory } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { TAG_ICONS_COMPONENTS_MAP } from '../../../../constants/story'

import { useStyles } from './styles'
import { numberWithCommas } from '../../../../utils'
import { LINKS } from '../../../../constants/routes'

import PatientCareIcon from '../../../Icons/tags/PatientCareIcon'

const TagsAndMood = ({ data: { tags } }) => {
  const history = useHistory()
  const classes = useStyles()

  return (
    <Grid container item xs={12} alignItems='center' justifyContent='space-between' className={classes.row}>
      <Grid container alignItems='center' justifyContent='center' item xs={12}>
        <div className={classes.leftBlock}>
          <Typography variant='h6' component='div' className={classes.label}>
            MOST TAGS
          </Typography>
          <div className={classes.tags} onClick={() => history.push(LINKS.STORIES_OVERVIEW)}>
            {tags.top.map((tag, idx) => {
              const mostTag = idx === 0 && tag.usageCount > 0
              const TagIconComponent = TAG_ICONS_COMPONENTS_MAP[tag.name] || PatientCareIcon
              return (
                <div key={tag.id} className={mostTag ? classes.mostTag : classes.tag}>
                  <Typography variant='h3' component='div' className={classes.amount}>
                    {numberWithCommas(tag.usageCount)}
                  </Typography>
                  <div className={classes.icon}>
                    <TagIconComponent size={64} key={tag.id} fillColor={mostTag ? '#FFFFFF' : '#8688A1'} />
                  </div>
                  <Typography variant='h6' component='div' className={classes.name}>
                    {tag.name}
                  </Typography>
                </div>
              )
            })}
          </div>
        </div>
      </Grid>
    </Grid>
  )
}

export default TagsAndMood
